module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_8-84b7fb0f1ed22b6d1b03885b6d36e8e7.jpg";